import {
  CANVAS_SIZES,
  MATERIAL_TYPES,
  TILE_SIZES,
  type FRAME_COLORS,
} from '@mixtiles/web-backend-shared'
import { useRouteLoaderData } from 'react-router'
import { usePricing } from 'components/Pricing/PricingProvider'
import { ALL_SIZES } from 'pages/DiscoveryPage/DiscoveryConsts'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useExperimentManager } from 'services/ExperimentManager/ExperimentManager'
import { useKeys } from 'services/KeysProvider'
import { getSizeName, isSizesInInches } from 'services/SizesManager'
import { getFrameColorName, getMaterialName } from 'utils/colorUtils'
import { formatPrice } from 'utils/utils'

export function useFrameColorName() {
  const { t } = useTranslation()

  return {
    getFrameColorName: useCallback(
      (
        frameColor: FRAME_COLORS,
        shouldAddWide?: boolean,
        materialType?: MATERIAL_TYPES
      ) => getFrameColorName(frameColor, shouldAddWide, materialType, t),
      [t]
    ),
    getMaterialName: useCallback(
      (materialType: MATERIAL_TYPES) => getMaterialName(materialType, t),
      [t]
    ),
  }
}
export function useSizeName() {
  const { t } = useTranslation()
  const { ipCountry } = useKeys()
  const isInches = useMemo(() => isSizesInInches(ipCountry), [ipCountry])

  return {
    isSizesInInches: isInches,
    getSizeName: useCallback(
      (size: string) => getSizeName(size, { country: ipCountry, t }),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [t]
    ),
  }
}
export function useOrderedSizes() {
  const experimentManager = useExperimentManager()

  return useCallback(
    (
      materialType = MATERIAL_TYPES.CLASSIC // this is a small hack to make sure this function works in SSR
    ) => {
      if (materialType === MATERIAL_TYPES.CANVAS) {
        return CANVAS_SIZES
      }

      const sizes: TILE_SIZES[] = []

      sizes.push(...ALL_SIZES)

      if (experimentManager.isEnabled('xl-sizes')) {
        sizes.push(TILE_SIZES.RECTANGLE_27X36, TILE_SIZES.RECTANGLE_36X27)
      }

      if (experimentManager.isEnabled('size-22x44')) {
        sizes.push(TILE_SIZES.RECTANGLE_22X44, TILE_SIZES.RECTANGLE_44X22)
      }

      return sizes
    },
    [experimentManager]
  )
}
export function useFormatPrice() {
  const { pricingData } = usePricing()
  const { ipCountry } = useKeys()

  return useCallback(
    (price: number) =>
      formatPrice(price, pricingData.currency, 2, false, ipCountry),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pricingData]
  )
}
export function useMaterialsAsColor() {
  const { isMaterialsUnderFrameEnabled } = useRouteLoaderData('root')

  return {
    isEnabled: isMaterialsUnderFrameEnabled,
  }
}
